var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isActive ? 'active': '',on:{"click":function($event){return _vm.toggle(_vm.index)}}},[_c('span',[_vm._t("default")],2),(_vm.isActive)?_c('div',{staticClass:"highlight"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }